import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const sessionStorage = {
  getItem: (key) => JSON.parse(window.sessionStorage.getItem(key)),
  setItem: (key, value) => window.sessionStorage.setItem(key, JSON.stringify(value)),
  removeItem: (key) => window.sessionStorage.removeItem(key),
};

export const authAtom = atomWithStorage('authState', null, sessionStorage);